import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminGuard } from './core/guards/admin.guard';

import { AuthGuard } from './core/guards/auth.guard';
import { GerenteGuard } from './core/guards/gerente.guard';
import { ValidadorGuard } from './core/guards/validador.guard';
import { VendedorGuard } from './core/guards/vendedor.guard';
import { LayoutComponent } from './shared/layout/layout.component';

const appRoutes: Routes = [

    //Login routing
    {
        path: '',
        loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
    },

    //Administrador Routing
    {
        path: 'administrador',
        component: LayoutComponent, // this is the component with the <router-outlet> in the template
        children: [
            {
                path: 'dashboard',
                loadChildren: () => import('./features/administrador/dashboard/dashboard.module').then(m => m.DashboardModule),
                canActivate: [AuthGuard, AdminGuard]
            },
            {
                path: 'account',
                loadChildren: () => import('./features/account/account.module').then(m => m.AccountModule),
                canActivate: [AuthGuard, AdminGuard]
            },
        ],
        canActivate: [AuthGuard, AdminGuard]
    },

    //Vendedor Routing
    {
        path: 'vendedor',
        component: LayoutComponent, // this is the component with the <router-outlet> in the template
        children: [
            {
                path: 'dashboard',
                loadChildren: () => import('./features/vendedor/dashboard/dashboard.module').then(m => m.DashboardModule),
                canActivate: [AuthGuard, VendedorGuard]
            },
            {
                path: 'calendario',
                loadChildren: () => import('./features/vendedor/calendar/calendar.module').then(m => m.CalendarModule),
                canActivate: [AuthGuard, VendedorGuard]
            },
            {
                path: 'prospectos',
                loadChildren: () => import('./features/vendedor/prospectus/prospectus.module').then(m => m.ProspectusModule),
                canActivate: [AuthGuard, VendedorGuard]
            },
            {
                path: 'clientes',
                loadChildren: () => import('./features/vendedor/client-account/client-account.module').then(m => m.ClientAccountModule),
                canActivate: [AuthGuard, VendedorGuard]
            },
            {
                path: 'contactos',
                loadChildren: () => import('./features/vendedor/client-contact/client-contact.module').then(m => m.ClientContactModule),
                canActivate: [AuthGuard, VendedorGuard]
            },
            {
                path: 'oportunidades',
                loadChildren: () => import('./features/vendedor/opportunity/opportunity.module').then(m => m.OpportunityModule),
                canActivate: [AuthGuard, VendedorGuard]
            },
            {
                path: 'reportes',
                loadChildren: () => import('./features/vendedor/report/report.module').then(m => m.ReportModule),
                canActivate: [AuthGuard, VendedorGuard]
            },
            {
                path: 'cotizaciones',
                loadChildren: () => import('./features/vendedor/quote/quote.module').then(m => m.QuoteModule),
                canActivate: [AuthGuard, VendedorGuard]
            },
            {
                path: 'account',
                loadChildren: () => import('./features/account/account.module').then(m => m.AccountModule),
                canActivate: [AuthGuard, VendedorGuard]
            },
        ],
        canActivate: [AuthGuard, VendedorGuard]
    },

    //Gerente Routing
    {
        path: 'gerente',
        component: LayoutComponent, // this is the component with the <router-outlet> in the template
        children: [
            {
                path: 'dashboard',
                loadChildren: () => import('./features/gerente/dashboard/dashboard.module').then(m => m.DashboardModule),
                canActivate: [AuthGuard, GerenteGuard]
            },
            {
                path: 'calendario',
                loadChildren: () => import('./features/gerente/calendar/calendar.module').then(m => m.CalendarModule),
                canActivate: [AuthGuard, GerenteGuard]
            },
            {
                path: 'prospectos',
                loadChildren: () => import('./features/gerente/prospectus/prospectus.module').then(m => m.ProspectusModule),
                canActivate: [AuthGuard, GerenteGuard]
            },
            {
                path: 'clientes',
                loadChildren: () => import('./features/gerente/client-account/client-account.module').then(m => m.ClientAccountModule),
                canActivate: [AuthGuard, GerenteGuard]
            },
            {
                path: 'oportunidades',
                loadChildren: () => import('./features/gerente/opportunity/opportunity.module').then(m => m.OpportunityModule),
                canActivate: [AuthGuard, GerenteGuard]
            },
            {
                path: 'contactos',
                loadChildren: () => import('./features/gerente/client-contact/client-contact.module').then(m => m.ClientContactModule),
                canActivate: [AuthGuard, GerenteGuard]
            },
            {
                path: 'reportes',
                loadChildren: () => import('./features/gerente/report/report.module').then(m => m.ReportModule),
                canActivate: [AuthGuard, GerenteGuard]
            },
            {
                path: 'account',
                loadChildren: () => import('./features/account/account.module').then(m => m.AccountModule),
                canActivate: [AuthGuard, GerenteGuard]
            },
        ],
        canActivate: [AuthGuard, GerenteGuard]
    },

    //Validator Routing

    {
        path:'validador',
        component: LayoutComponent, // this is the component with the <router-outlet> in the template
        children: [
            {
                path: 'solicitudes',
                loadChildren: () => import('./features/validador/request/request.module').then(m => m.RequestModule),
                canActivate: [AuthGuard, ValidadorGuard]
            }
        ],
        canActivate: [AuthGuard, ValidadorGuard]
    },

    //Generic error routing
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' })
    ],
    exports: [RouterModule],
    providers: []
})
export class AppRoutingModule { }
